import { Component } from "react";
import PropTypes from "prop-types";

class ConfigManager extends Component {
  constructor(props) {
    super(props);
    const { getConfig } = props;
    getConfig();
  }
  render() {
    return null;
  }
}

ConfigManager.propTypes = {
  getConfig: PropTypes.func.isRequired,
};

export default ConfigManager;



// WEBPACK FOOTER //
// ./src/components/common/config-manager/config-manager.jsx